 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		50: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		50: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"LearnosityEduAuthor","29":"MemberHomepage","30":"MyCollections","31":"MyStudents","32":"Onboarding","33":"PracticeSkill","34":"PredefinedCollectionsDetail","35":"Pricing","36":"ProgressTracker","37":"RegistrationModal","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SwitchAccountModal","44":"TakeAssessmentModal","45":"vendors~Checkout","46":"vendors~Gift","47":"vendors~MemberHomepage","48":"vendors~MyStudents","49":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"969346461908332e2355","1":"4b73b7f0220c4e961f71","2":"d1b0e8f39028dd3fa518","3":"9a46ac6adc87635913a7","4":"d4aa895afc382dd2f98a","5":"45f7348cf509147df384","6":"b6b3a024906420f0830c","7":"4c16ce6356954f57cf0a","8":"7c83ac812d40ccb83028","9":"e6ddca8fb12336301efb","10":"21beb249caa38c9f9be3","11":"fb68403c4515afabd059","12":"2928b68b90b7696b7e8f","13":"54c314d7edf83dda5455","14":"addddd90bc4729f8f641","15":"ee956829909bc76da698","16":"4ece3d6970b7119d1a35","17":"5fc8ce47fbee11c7ccac","18":"8050a0f1484006dc6aae","19":"9a01e14d4023c00c620a","20":"998d4ff3425504c481d8","21":"08ac5167c0f9dee316f9","22":"3ed6c8eb55f3a48e6d93","23":"b9ccdb85edcbfb6899a8","24":"d7fabb9382831b336b67","25":"8ce6c48ff2894de6ef74","26":"39a880fca8dfbb790d59","27":"09de5522741cc1e7d261","28":"87b801fe67c8025dfaf1","29":"7c02987aa5654b78351f","30":"85a7d440e1a134ee61c6","31":"63b0ba55969bfd17f56c","32":"b6cf73899a1a8eda488b","33":"2b9f5a310c7b58326b15","34":"3742722e7427decc2f46","35":"800f90be709f45d45a8e","36":"c25a7aaffadc233ae84d","37":"60bfea61593c6e93d14c","38":"848cfbb6b875355e5b2b","39":"f6f9e2382ca4fcd9697b","40":"c45b73079a0380d244fb","41":"78c40f8b1cccfbea1059","42":"e1368fe260e8b8f7b31c","43":"64e23f7b0d9914adba3b","44":"07c589871ecf851ad480","45":"ae9683d54a56a3d227b9","46":"f37262fdd8f1f3b3d8b1","47":"70d92eb3e740c2d62900","48":"2a2fb9ae684653784c27","49":"8eb5c159b1faee6fa73a","52":"eb01f4ff25674eb1ab31","53":"b84eee31deb728bcc852"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1,"8":1,"9":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"35":1,"36":1,"39":1,"40":1,"41":1,"44":1,"46":1,"52":1,"53":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"LearnosityEduAuthor","29":"MemberHomepage","30":"MyCollections","31":"MyStudents","32":"Onboarding","33":"PracticeSkill","34":"PredefinedCollectionsDetail","35":"Pricing","36":"ProgressTracker","37":"RegistrationModal","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SwitchAccountModal","44":"TakeAssessmentModal","45":"vendors~Checkout","46":"vendors~Gift","47":"vendors~MemberHomepage","48":"vendors~MyStudents","49":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"21c26712ad69a7171d89","7":"31d6cfe0d16ae931b73c","8":"d83f7d79e0dedcc0dc59","9":"7940bf3d212a1d969f31","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"4ad35bb3dca41c2cae0b","13":"2ea02414d9a3800d915f","14":"13a4e7436120b3088257","15":"681ffe45eaa49fb7d947","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"8ea7780d464a38402b20","19":"d56d9288e4c0c7368f48","20":"7c9ade4d0722da2d712c","21":"ba6307e6a97b2de53684","22":"721e02162f6078ce1480","23":"fd2c2b017f0caffc689f","24":"4c89bea8f7f35505c32a","25":"d01ca0b2bc1b700e7195","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"8300fbd3904f23f3370c","29":"24b76c83c43ecfb159b5","30":"ab19f0324e469dc86f86","31":"db07f627a27d29aafe41","32":"3e3946facd93a178be00","33":"5491656ee574e8b4a49d","34":"31d6cfe0d16ae931b73c","35":"1320f4897b7b95eaec24","36":"749f9f37a66213e7a2d5","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"3eb70bdfce6885905434","40":"eaafc727492eb4363427","41":"ba010189d2bfdd022601","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"bf40f2159a5c06b0446f","45":"31d6cfe0d16ae931b73c","46":"ca68f8fa1dd9edae64fc","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","52":"c7c112df630d782cdeed","53":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([395,51]);
 	// run deferred modules when ready
 	return checkDeferredModules();
